import * as Highcharts from 'highcharts';
import {
  HIGHCHARTS_ALLOWED_ATTRIBUTES,
  HIGHCHARTS_ALLOWED_TAGS,
} from './highcharts-ast.constants';

// Highcharts strips non-allowlisted tags/attrs from useHTML tooltips, dropping inline <svg> legend icons.
export const allowHighchartsSvgIcons = (): void => {
  Highcharts.AST.allowedTags = [
    ...new Set([...Highcharts.AST.allowedTags, ...HIGHCHARTS_ALLOWED_TAGS]),
  ];
  Highcharts.AST.allowedAttributes = [
    ...new Set([
      ...Highcharts.AST.allowedAttributes,
      ...HIGHCHARTS_ALLOWED_ATTRIBUTES,
    ]),
  ];
};
